<template>
  <section class="record-summary-section">
    <h3 v-if="title" class="record-summary-title">{{ title }}</h3>
    <a-descriptions v-if="record" size="small" bordered :column="{ xs: 1, sm: 2, lg: 3 }">
      <a-descriptions-item v-for="field in fields" :key="field.key" :label="field.label">
        <PaymentMethodTag v-if="field.providerTradeType || field.paymentType || field.provider" :record="record" :field="field" />
        <span v-else class="record-summary-value">{{ formatRecordField(record, field) }}</span>
      </a-descriptions-item>
    </a-descriptions>
    <p v-else class="record-summary-empty">{{ emptyText }}</p>
  </section>
</template>

<script setup>
import { formatRecordField } from "@/utils/orderRecordTypes";
import PaymentMethodTag from "@/components/PaymentMethodTag.vue";
defineProps({
  title: { type: String, default: "" },
  record: { type: Object, default: null },
  fields: { type: Array, required: true },
  emptyText: { type: String, default: "未找到对应记录" },
});
</script>

<style scoped>
.record-summary-section { margin-bottom: 20px; }
.record-summary-title { margin: 0 0 10px; font-size: 14px; font-weight: 600; }
.record-summary-value { white-space: pre-wrap; overflow-wrap: anywhere; word-break: break-word; font-variant-numeric: tabular-nums; }
.record-summary-empty { margin: 0; color: rgba(0, 0, 0, 0.65); }
</style>
